import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const addUserBank = createAsyncThunk(
    '/add/addUserBank',
    async (add) => {

        try {
            const myurl = `${PAY_URL}/user/manage-bank`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: add,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const addUserBank = response.data;
            // console.log(addUserBank, '@@@')

            if (addUserBank.success === true) {
                toast.success(addUserBank?.message);
                return addUserBank;
            } else {
                // console.log(addUserBank.message, "&&&&")
                throw new Error(addUserBank.message);
            }
        } catch (error) {
            console.log(error, "!!!!")
            toast.error(error.response.data.message);
            return error;
        }
    }
);


const addUserBankSlice = createSlice({
    name: "addUserBank",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addUserBank.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addUserBank.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(addUserBank.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default addUserBankSlice.reducer;